/* Screen ids to URLs, and back. Moved out of the client store on 2 Aug 2026
   so the server can answer the question too: it serves the first request for
   every client route and has to know which screen that URL is, in order to put
   the right title and description in the head (see ./pagemeta.ts).

   Real URLs matter for magic-link landing, refresh, and future public profiles
   (implementation plan section 8). */
export const PATHS: Array<[screen: string, pattern: string]> = [
  ["today", "/"],
  ["practices", "/practice"],
  ["discover", "/discover"],
  ["feed", "/feed"],
  ["crossfire", "/crossfire"],
  ["follow", "/follow"],
  ["expert", "/experts"],
  ["controls", "/controls"],
  ["review", "/review"],
  ["welcome", "/welcome"],
  ["onb-areas", "/start/areas"],
  ["onb-experts", "/start/experts"],
  ["onb-email", "/start/email"],
  ["signin", "/signin"],
  ["program", "/program"],
  ["about", "/about"],
  ["contact", "/contact"],
  ["privacy", "/privacy"],
  ["terms", "/terms"],
  ["health", "/health-data"],
];

export interface Frame {
  s: string;
  a: string | null;
}

export function pathFor(screen: string, arg: string | null): string {
  const entry = PATHS.find(([s]) => s === screen);
  if (!entry) return "/";
  const base = entry[1];
  return arg ? `${base === "/" ? "" : base}/${arg}` : base;
}

/* Longest pattern first, so /start/areas is not swallowed by a shorter
   prefix, and an unknown path resolves to today the way the client has always
   treated it: the shell renders something rather than nothing. */
export function parsePath(pathname: string): Frame {
  if (pathname === "/") return { s: "today", a: null };
  const sorted = [...PATHS].sort((a, b) => b[1].length - a[1].length);
  for (const [screen, base] of sorted) {
    if (base === "/") continue;
    if (pathname === base) return { s: screen, a: null };
    if (pathname.startsWith(`${base}/`)) {
      return { s: screen, a: decodeURIComponent(pathname.slice(base.length + 1)) };
    }
  }
  return { s: "today", a: null };
}

/* An exact match only: /experts/huberman is the expert screen but it is not a
   page this table can describe, and a caller asking "which page is this URL"
   needs to hear no rather than "the profile screen, generically". */
export function screenForPath(pathname: string): string | null {
  if (pathname === "/") return "today";
  const hit = PATHS.find(([, base]) => base === pathname);
  return hit ? hit[0] : null;
}
